<template>
  <v-container class="pa-0" fluid>
    <v-card>
      <v-card-actions wrap class="card-bg-2 py-0 layout wrap">
        <v-btn class="my-2 ml-0 mr-2" disabled color="info" @click="generateGraph" id="step18">
          <v-icon class="mr-1">insert_chart</v-icon>
          <div class="text-capitalize">{{ $t('Button.Generate_Graph') }}</div>
        </v-btn>
        <v-btn class="my-2 ml-0 mr-2" @click="generateTabular()">
          <v-icon class="mr-1">storage</v-icon>
          <div class="text-capitalize">{{ $t("Button.View_As_Tabular") }}</div>
        </v-btn>
        <v-btn
          class="my-2 ml-0"
          :loading="loadingDownloadData"
          @click="downloadData()"
        >
          <v-icon class="mr-1">save_alt</v-icon>
          <div class="text-capitalize">
            {{ $t("Button.DownloadExcelReport") }}
          </div>
        </v-btn>
      </v-card-actions>
      <v-divider />
      <v-progress-linear
        v-if="mainInterfaceIsLoading"
        :indeterminate="mainInterfaceIsLoading"
      ></v-progress-linear>
      <v-layout wrap class="card-bg-2">
        <v-flex xs12 md5 class="divider-right">
          <v-card-title class="headline pb-0">Survey Types</v-card-title>
          <v-card-text class="py-0">
            <v-radio-group
              v-if="availableSurveyTypes && availableSurveyTypes.length > 0"
              v-model="selectedSurveyType"
              row
            >
              <template v-for="m in availableSurveyTypes">
                <v-radio color="info" :key="m" :label="m" :value="m"></v-radio>
              </template>
            </v-radio-group>
            <!-- <div class="py-4 secondary--text text--lighten-1" v-if="!analyteMediaTypes || analyteMediaTypes == 0">
              There are no media types available
            </div> -->
          </v-card-text>
          <v-divider />

          <v-card-title class="headline">Date Range</v-card-title>
          <v-card-text class="py-0">
            <DateRange
              v-model="dates"
              rounded
              solo
              :minDate="minDate"
              :maxDate="maxDate"
              :selectedRange.sync="selectedRange"
              :availableDateRange="{ start: minDate, end: maxDate }"
              :min-max-placeholder="formats.prettyDateFormat"
              :shortcutPrefix="'Show'"
              :shortcuts="shortcuts"
              no-arrows
              :data="availableData"
            />
          </v-card-text>
          <v-divider />
          <!-- <v-card-title class="headline">Aggregation Options</v-card-title>
          <v-card-text class="py-0 pb-2">
            <span
              >Numeric fields with multiple samples per date can be aggregated
              using various schemes.</span
            >
          </v-card-text>
          <v-divider />
          <v-data-table
            :headers="aggregationHeaders"
            :items="selectedAggregationVariables"
            :item-key="ID_KEY"
          >
            <template v-slot:items="props">
              <tr>
                <td>{{ props.item.Variable }}</td>
                <td>
                  <v-select
                    v-model="props.item.Aggregations"
                    :items="dataAggregationTypeValues"
                    multiple
                    label="Aggregations"
                    chips
                    box
                    dense
                  ></v-select>
                </td>
              </tr>
            </template>
            <template v-slot:no-data>
              <div class="pa-4 text-xs-center">
                <v-icon color="info">info</v-icon>
                <br />
                To use aggregation, please select numeric data with multiple
                samples per date
              </div>
            </template>
          </v-data-table>
          <v-divider /> -->
        </v-flex>
        <v-flex xs12 md7 class="divider-left">
          <v-card-title>
            <div
              class="headline pb-0"
              style="align-items: baseline; display: flex"
            >
              Location Variables
            </div>
            <v-spacer />
            <v-text-field
              prepend-inner-icon="search"
              v-model="search"
              class="rounded font-weight-regular"
              hide-details
              clearable
              solo
              placeholder="Search location variables"
            />
          </v-card-title>
          <v-card-text class="py-0 px-0">
            <v-item-group
              mandatory
              v-model="filterToggle"
              active-class="white--text"
            >
              <v-subheader style="display: inline; cursor: default"
                >Show:</v-subheader
              >
              <v-item>
                <v-chip
                  small
                  slot-scope="{ active, toggle }"
                  :color="active ? 'primary' : 'default'"
                  :selected="active"
                  class="chipFilter"
                  @click="toggle"
                  >All</v-chip
                >
              </v-item>
              <v-item>
                <v-chip
                  small
                  slot-scope="{ active, toggle }"
                  :color="active ? 'primary' : 'default'"
                  :selected="active"
                  class="chipFilter"
                  @click="toggle"
                >
                  <v-avatar class="chip-log-count" style="border-radius: 0px">{{
                    selected.length
                  }}</v-avatar>
                  Selected
                </v-chip>
              </v-item>
            </v-item-group>
            <v-divider />
            <v-data-table
              v-model="selected"
              :search="search"
              :headers="headers"
              select-all
              :pagination.sync="pagination"
              :items="availableLocationVariables"
              :item-key="ID_KEY"
              :loading="surveyVariables.isLoading"
            >
              <template v-slot:headers="props">
                <tr>
                  <th>
                    <v-checkbox
                      color="primary"
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                      primary
                      hide-details
                      @click.stop="toggleAll()"
                    ></v-checkbox>
                  </th>
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="[
                      'column sortable',
                      pagination.descending ? 'desc' : 'asc',
                      header.value === pagination.sortBy ? 'active' : '',
                    ]"
                    @click="changeSort(header.value)"
                  >
                    <v-icon small>arrow_upward</v-icon>
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <tr
                  class="clickable"
                  :active="props.selected"
                  @click="props.selected = !props.selected"
                >
                  <td>
                    <v-checkbox
                      @click.prevent
                      color="info"
                      hide-details
                      :input-value="props.selected"
                    />
                  </td>
                  <td>{{ props.item.VariableName }}</td>
                  <td>{{ props.item.DataType }}</td>
                  <td class="text-xs-center">
                    {{
                      formatDateTime(props.item.FirstRecordDateTime, {
                        format: formats.prettyDateTimeFormat,
                      })
                    }}
                  </td>
                  <td class="text-xs-center">
                    {{
                      formatDateTime(props.item.LastRecordDateTime, {
                        format: formats.prettyDateTimeFormat,
                      })
                    }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.NumberOfRecords }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-flex>
      </v-layout>
    </v-card>
    <LocationSurveyQueryResultTabularView
      v-model="showTabularView"
      :data="queryResults.data"
      :aggregateColumns="aggregateColumns"
      :startDate="dates.start"
      :endDate="dates.end"
      :hasQueriedAggregateData="hasQueriedAggregateData"
      :showAllValues.sync="showAllValues"
      :loading="queryResults.isLoading"
      @refresh="executeSurveyQuery"
    />
    
    <FileDownloadModal
      v-model="showFileResultDownload"
      title="Report Result Download"
      :fileResults="fileResults"
    />
  </v-container>
</template>

<script>
import { max, min } from 'date-fns'
import format from 'date-fns/format'
import moment from 'moment'
import { createNamespacedHelpers } from 'vuex'

import MomentUtil from '@/components/mixins/MomentUtil'
import DateRange from '@/components/generic/DateRange'
import {
  prettyDateTimeFormat,
  prettyDateFormat,
  newDateStringNoTimezone,
    newDateStringNoTimezoneAddOneDay,
} from '@/components/mixins/MomentUtil'

import { dataAggregationTypes } from '@/components/MonitoringFeature/DataSources/SurveyEnvirodata/surveyAggregation'
import LocationSurveyQueryResultTabularView from '@/components/MonitoringFeature/DataSources/SurveyEnvirodata/TabularView/LocationSurveyQueryResultTabularView'
const SEARCH_KEY = 'Variable'
const ID_KEY = 'Id'
import { isNumericType } from '@/components/generic/KVStore/kvValueHelper'
import { ShowAllValue, ShowValueOnly } from '@/helpers/dataFilter'
const app = createNamespacedHelpers('app')
const vegetativemonitoring = createNamespacedHelpers('vegetativemonitoring')

import FileDownloadModal from '@/components/VegetativeMonitoring/PlotDetail/Tabs/FileDownloadModal'

const monitoringFeatures = createNamespacedHelpers('monitoringfeature')

import { SOURCE_TYPES } from '@/store/MonitoringFeature/monitoringfeature'

export default {
  components: {
    DateRange,
    LocationSurveyQueryResultTabularView,
    FileDownloadModal,
  },
  mixins: [MomentUtil],
  data() {
    return {
      ID_KEY,
      loadingDownloadData: false,
      filter: {
        items: [],
      },
      filterToggle: 0,
      search: '',
      selectedRange: null,
      selected: [],
      surveyVariables: {
        isLoading: false,
        data: {},
      },
      pagination: {
        sortBy: SEARCH_KEY,
        rowsPerPage: 10,
        page: 1,
      },
      items: [],
      dates: {
        start: null,
        end: null,
      },
      formats: {
        prettyDateFormat,
        prettyDateTimeFormat,
      },
      defaultDateFormat: {
        format: prettyDateTimeFormat,
      },
      queryResults: {
        isLoading: false,
        data: [],
      },
      downloadResults: {
        isLoading: false,
        data: [],
      },
      showAllValues: false,
      showTabularView: false,
      showFileResultDownload: false,
      selectedSurveyType: null,
    }
  },
  computed: {
    ...monitoringFeatures.mapGetters(['currentFeatureDataSourceData']),
    dataSource() {
      const data = this.currentFeatureDataSourceData(
        SOURCE_TYPES.surveysEnvirodata
      )
      return data
    },
    availableSurveyTypes() {
      return this.dataSource.SurveyTypes
    },
    ...vegetativemonitoring.mapState(['reportGenerator']),
    availableData() {
      if (this.items  == null || this.items.length == 0) {
        return []
      }
      var startDates = this.items.map(x => x.FirstRecordDateTime)
      var endDates = this.items.map(x => x.LastRecordDateTime)
      var dates = [...new Set(startDates.concat(endDates))] 
      return dates
      //return this.plot.Surveys.map((x) => new Date(x.SurveyDateTimeRaw))
    },
    minDate() {
      return min(...this.availableData)
    },
    maxDate() {
      return max(...this.availableData)
    },
    allHeaders() {
      return {
        variable: {
          text: 'Variable Name',
          align: 'center',
          value: 'VariableName',
        },
        dataType: {
          text: 'Data Type',
          align: 'center',
          value: 'DataType',
        },
        firstRecordDate: {
          text: 'First Record',
          align: 'center',
          value: 'FirstRecordDateTime',
        },
        lastRecordDate: {
          text: 'Last Record',
          align: 'center',
          value: 'LastRecordDateTime',
        },
        numberOfRecords: {
          text: '# Records',
          align: 'center',
          value: 'NumberOfRecords',
        },
      }
    },
    headers() {
      return Object.values(this.allHeaders)
    },
    shortcuts() {
      return {
        all: {
          name: () => 'All available data',
          make: () => {
            return {
              start: moment(this.minDate),
              end: moment(this.maxDate),
            }
          },
        },
      }
    },
    aggregationHeaders() {
      return [
        {
          text: 'Variable Name',
          align: 'center',
          value: 'Variable',
        },
        {
          text: 'Aggregations',
          align: 'center',
          value: 'Aggregations',
        },
      ]
    },
    selectedAggregationVariables() {
      return this.selected.filter((x) => {
        return x.HasAggregateValue && isNumericType(x.DataType)
      })
    },
    dataAggregationTypeValues() {
      return Object.values(dataAggregationTypes)
    },
    surveyQueryVariables() {
      let variables = {}
      this.selected.forEach((x) => {
        if (variables[x.VariableName] == null) {
          variables[x.VariableName] = {
            VariableName: x.VariableName,
            ValueTypes: [x.DataType],
            Aggregations: x.Aggregations || [],
          }
        } else {
          variables[x.VariableName].ValueTypes.push(x.DataType)
          variables[x.VariableName].Aggregations = variables[
            x.VariableName
          ].Aggregations.concat(x.Aggregations)
        }
      })
      return Object.values(variables)
    },
    aggregateColumns() {
      let colSet = {}
      this.selected.forEach((sel) => {
        sel.Aggregations.forEach((agg) => {
          colSet[agg] = 1
        })
      })
      return Object.keys(colSet)
    },
    fileResults() {
      if (this.downloadResults.data.fileResults == null) {
        return []
      }
      return this.downloadResults.data.fileResults
    },
    mainInterfaceIsLoading() {
      return this.downloadResults.isLoading || this.queryResults.isLoading
    },
    dataIsSelected() {
      return this.selected.length > 0
    },
    hasQueriedAggregateData() {
      return (
        this.selectedAggregationVariables.filter(
          (variable) => variable.Aggregations.length > 0
        ).length > 0
      )
    },
    availableLocationVariables() {
      var itemsOfSurveyType = this.items.filter(x => x.SurveyType == this.selectedSurveyType)
      if (itemsOfSurveyType == null) {
        return []
      }
      return itemsOfSurveyType
    },
  },
  watch: {    
    showTabularView() {
      if (!this.showTabularView) {
        this.resetQueryResults()
        this.showAllValues = false
      }
    },
    showAllValues() {
      if (this.showTabularView) {
        this.executeSurveyQuery()
      }
    },
  },
  methods: {
    ...app.mapActions(['setSnackbar']),
    ...vegetativemonitoring.mapActions(['fetchReportGenerator']),
    format,
    generateGraph() {},
    async generateTabular() {
      if (!this.checkDataIsSelected()) {
        return
      }
      try {
        await this.executeSurveyQuery()
        this.showTabularView = true
      } catch (error) {
        this.handleError(error)
      }
    },
    async downloadData() {
      if (!this.checkDataIsSelected()) {
        return
      }
      try {
        await this.executeSurveyReportDownload()
        console.log('finished downloading')
        this.showFileResultDownload = true
      } catch (error) {
        this.handleError(error)
      }
    },
    toggle() {},
    toggleAll() {
      let selectedDict = {}

      this.selected.forEach((item) => {
        selectedDict[item[ID_KEY]] = item
      })

      if (this.items.every((item) => selectedDict[item[ID_KEY]])) {
        this.items.forEach((item) => {
          delete selectedDict[item[ID_KEY]]
        })
      } else {
        this.items.forEach((item) => {
          selectedDict[item[ID_KEY]] = item
        })
      }

      this.selected = Object.values(selectedDict)
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    async getLocationSurveyVariables() {
      if (this.dataSource != null && this.dataSource.Guid != null) {
        try {
          this.surveyVariables.isLoading = true
          let res = await this.axios.get(
            'api/Surveys/LocationSurveys/header',
            {
              params: {
                locationId: this.dataSource.Guid,
              },
            }
          )
          this.surveyVariables.data = res.data
          
          this.items = this.transformSurveyVariableData(
            this.surveyVariables.data
          )
        } catch (error) {
          this.handleError(error)
        } finally {
          this.surveyVariables.isLoading = false
        }
      }
    },
    transformSurveyVariableData(surveyVariables) {
      // var itemsOfSurveyType = surveyVariables.filter(x => x.SurveyType == this.selectedSurveyType)
      // if (itemsOfSurveyType == null) {
      //   return []
      // }
      var itemsForSelected = surveyVariables.map((x) => ({
        Id: this.selectedSurveyType + '-' + x.VariableName,
        VariableName: x.VariableName,
        DataType: x.DataType,
        FirstRecordDateTime: x.FirstRecordDateTime,
        LastRecordDateTime: x.LastRecordDateTime,
        NumberOfRecords: x.NumberOfRecords, 
        HasAggregateValue: false,
        Aggregations: [],
        SurveyType: x.SurveyType,
      }))
      return itemsForSelected
      // var variables = Object.values(surveyVariables.Pairs)
      // return variables.reduce((acc, surveyVar) => {
      //   let entries = surveyVar.PairTypes.map((dataType) => ({
      //     Id: `${surveyVar.PairKey}-${dataType}`,
      //     Variable: surveyVar.PairKey,
      //     DataType: dataType,
      //     FirstRecordDate: surveyVar.PairTypeIndices[dataType].reduce(
      //       (a, b) => (a < b ? a : b),
      //       surveyVar.PairTypeIndices[dataType][0]
      //     ),
      //     LastRecordDate: surveyVar.PairTypeIndices[dataType].reduce(
      //       (a, b) => (a > b ? a : b),
      //       surveyVar.PairTypeIndices[dataType][0]
      //     ),
      //     NumberOfRecords: surveyVar.PairTypeIndices[dataType].length,
      //     HasAggregateValue: surveyVar.HasAggregateValue,
      //     Aggregations:
      //       surveyVar.HasAggregateValue && isNumericType(dataType)
      //         ? [dataAggregationTypes['mean'].value]
      //         : [],
      //   }))
      //   return acc.concat(entries)
      // }, [])
    },
    async executeSurveyQuery() {
      let payload = {
        LocationId: this.dataSource.Guid,
        SurveyType: this.selectedSurveyType,
        Variables: this.surveyQueryVariables,
        StartDate: newDateStringNoTimezone(this.dates.start),
        EndDate: newDateStringNoTimezoneAddOneDay(this.dates.end),
        FilterMode: this.showAllValues ? ShowAllValue : ShowValueOnly,
      }
      try {
        this.$set(this.queryResults, 'isLoading', true)
        this.resetQueryResults(false)
        let res = await this.axios.post(
          'api/Surveys/LocationSurveys/query',
          payload
        )
        this.queryResults.data = res.data
      } catch (error) {
        throw error
      } finally {
        this.$set(this.queryResults, 'isLoading', false)
      }
    },
    async executeSurveyReportDownload() {
      console.log('download report', this.reportingService)
      let payload = {
        ServiceId: this.reportGenerator && this.reportGenerator.Id,
        LocationId: this.dataSource.Guid,
        SurveyType: this.selectedSurveyType,
        Variables: this.surveyQueryVariables,
        StartDate: newDateStringNoTimezone(this.dates.start),
        EndDate: newDateStringNoTimezoneAddOneDay(this.dates.end),
        FilterMode: this.showAllValues ? ShowAllValue : ShowValueOnly,
        ReportConfig: {},
      }
      try {
        this.downloadResults.isLoading = true
        let res = await this.axios.post(
          'api/Surveys/LocationSurveys/Download',
          payload
        )
        this.downloadResults.data = res.data
      } catch (error) {
        throw error
      } finally {
        this.downloadResults.isLoading = false
      }
    },
    initializeDates() {
      this.dates.start = this.dates.start || this.minDate
      this.dates.end = this.dates.end || this.maxDate
    },
    handleError(error) {
      console.error(error)
      this.setSnackbar({
        text: error.message,
        color: 'error',
      })
    },
    checkDataIsSelected() {
      let result = this.dataIsSelected
      if (!result) {
        this.notifyToSelectData()
      }
      return result
    },
    notifyToSelectData() {
      this.setSnackbar({
        text: 'Please select at least one variable',
        color: 'info',
        icon: 'info',
      })
    },
    resetQueryResults(resetIsLoading = true) {
      this.$set(this.queryResults, 'data', [])
      if (resetIsLoading) {
        this.$set(this.queryResults, 'isLoading', false)
      }
    },
  },
  created() {
    this.fetchReportGenerator()
    this.getLocationSurveyVariables()
    this.initializeDates()
    this.selectedSurveyType = this.dataSource.SurveyTypes[0]
  },
}
</script>